import { ActionCard } from '@shared/ui-components/action-card/data/action-card.model';
import { ProcedureCodes } from '@core/domain/model/procedures/procedure-codes';

import { AllRouteNamesType } from 'src/app/app.routes';

export type ProcedureType = ActionCard & {
  route: AllRouteNamesType;
  code: ProcedureCodes;
  group?: Group;
};

export type GroupType = {
  type: Group;
  desc: string;
};

export enum Group {
  INVOICE = 'invoice',
  CONTRACT = 'contract',
  COMPLAINT = 'complaint',
}

export enum ProcedureTypesDescriptions {
  // CRM
  PAYMENT_DEFERMENT = 'PROCEDURES.TYPES.PAYMENT_DEFERMENT', // Solicitud de aplazamiento de pagos
  INVOICE_CONCEPT = 'PROCEDURES.TYPES.INVOICE_CONCEPT', // Solicitud de información de concepto de factura
  PORTUGAL_INVOICE_CONCEPT = 'PROCEDURES.TYPES.PORTUGAL_INVOICE_CONCEPT', // Solicitud de información de concepto de factura
  CANCELLATION = 'PROCEDURES.TYPES.CANCELLATION', // Solicitud de baja
  PORTUGAL_CANCELLATION = 'PROCEDURES.TYPES.PORTUGAL_CANCELLATION', // Solicitud de baja en Portugal
  PORTUGAL_CYCLE_CHANGE = 'PROCEDURES.TYPES.PORTUGAL_CYCLE_CHANGE', // Solicitud de cambio de ciclo
  POWER_TARIFF_CHANGE = 'PROCEDURES.TYPES.POWER_TARIFF_CHANGE', // Solicitud de cambio potencias/tarifa
  PORTUGAL_POWER_CHANGE = 'PROCEDURES.TYPES.PORTUGAL_POWER_CHANGE', // Solicitud de cambio de potencia
  ACCOUNT_CHANGE = 'PROCEDURES.TYPES.ACCOUNT_CHANGE', // Solicitud de cambio de cuenta bancaria
  PORTUGAL_ACCOUNT_CHANGE = 'PROCEDURES.TYPES.PORTUGAL_ACCOUNT_CHANGE', // Solicitud de cambio de cuenta bancaria
  INVOICE_ADDRESS_CHANGE = 'PROCEDURES.TYPES.INVOICE_ADDRESS_CHANGE', // Solicitud de cambio de dirección facturación
  PORTUGAL_CHANGE_BILLING_CONTACTS = 'PROCEDURES.TYPES.PORTUGAL_CHANGE_BILLING_CONTACTS', // Cambio de contactos de facturación
  CONCEPTS_DISCREPANCY = 'PROCEDURES.TYPES.CONCEPTS_DISCREPANCY', // Discrepancia otros conceptos en factura emitida
  POWER_DISCREPANCY = 'PROCEDURES.TYPES.POWER_DISCREPANCY', // Discrepancia en potencias de factura emitida
  PORTUGAL_POWER_DISCREPANCY = 'PROCEDURES.TYPES.PORTUGAL_POWER_DISCREPANCY', // Discrepancia en potencias de factura emitida en Portugal
  MEASUREMENT_DISCREPANCY = 'PROCEDURES.TYPES.MEASUREMENT_DISCREPANCY', // Discrepancia en medida de factura emitida
  INVOICE_DELAY = 'PROCEDURES.TYPES.INVOICE_DELAY', // Retraso emisión facturas
  OUTAGES_FAILURES = 'PROCEDURES.TYPES.OUTAGES_FAILURES', // Cortes o averías
  PORTUGAL_OUTAGES_FAILURES = 'PROCEDURES.TYPES.PORTUGAL_OUTAGES_FAILURES', // Cortes o averías
  SELF_CONSUMPTION_CHANGE = 'PROCEDURES.TYPES.SELF_CONSUMPTION_CHANGE', // Alta/Modificación autoconsumo
  HOLDER_CHANGE = 'PROCEDURES.TYPES.HOLDER_CHANGE', // Cambio de titular
  PORTUGAL_HOLDER_CHANGE = 'PROCEDURES.TYPES.PORTUGAL_HOLDER_CHANGE', // Cambio de titular PORTUGAL
  MEASUREMENT_FILE_INCIDENCE = 'PROCEDURES.TYPES.MEASUREMENT_FILE_INCIDENCE', // Incidencia con fichero de medidas
  PORTUGAL_MEASUREMENT_FILE_INCIDENCE = 'PROCEDURES.TYPES.PORTUGAL_MEASUREMENT_FILE_INCIDENCE', // Incidencia con fichero de medidas en portugal
  PORTUGAL_INVOICE_DELAY = 'PROCEDURES.TYPES.PORTUGAL_INVOICE_DELAY', // Emision de factura en Portugal
  PORTUGAL_METER_READING = 'PROCEDURES.TYPES.PORTUGAL_METER_READING', // Incidencia con fichero de medidas
}
